module.exports = __webpack_public_path__ + "static/media/icon_logo.a1cbb766.png";